import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import StockDiscountService from "../../Controller/StockDiscountController";
import DiscountTypeService from "../../../Setup/controller/StockCategoryController/StockCategoryController";
import CreateStockDiscount from "./CreateStockDiscount";
import CreateStockDiscountCategory from "./CreateStockDiscountCategory";
import PartService from "../../Controller/PartController";
import StockDiscountCategoryService from "../../Controller/StockDiscountCategoryController";
import { handleChange, handleSubmit } from "../../Controller/UpdateDiscountType";
import HelpSite from "../../../Common/HelpLink";
function StockDiscountPage({ StockID }) {
    StockID = localStorage.getItem('StockID');
    const navigate = useNavigate();
    const location = useLocation();

    const PartID = StockID;

    const [DiscountTypeList, setDiscountTypeData] = useState([]);
    const [StockDiscountList, setStockDiscountData] = useState([]);
    const [stockDiscountCategoryData, setStockDiscountCategoryData] = useState([]);
    const [modalInstance, setModalInstance] = useState(null);
    const [currentStockDiscount, setcurrentStockDiscount] = useState(null);
    const [DiscountType, setDiscountType] = useState("");
    const [formData, setFormData] = useState({ DiscountTypeID: 0 });
    const [errors, setErrors] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [IsModalDiscount, setIsModalDiscount] = useState(false);
    const [currentStockDiscountCategory, setcurrentStockDiscountCategory] = useState(null);
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const fetchStockDiscount = async () => {
        try {
            const data = await StockDiscountService.GetAllStockDiscounts(redirectCallback, PartID);
            setStockDiscountData(data);
        } catch (error) {
            console.error('Error fetching stock discounts:', error);
        }
    };
    const fetchStockDiscountCategory = async () => {
        try {
            const data = await StockDiscountCategoryService.GetStockDiscountCategory(redirectCallback, PartID);
            setStockDiscountCategoryData(data);
        } catch (error) {
            console.error('Error fetching stock discounts:', error);
        }
    };

    const fetchPart = async () => {
        try {
            const data = await PartService.GetAllParts(redirectCallback, PartID);
            if (data.length > 0) {
                setDiscountType(data[0].FK_StockCategory_ID);
            }
        } catch (error) {
            console.error('Error fetching parts:', error);
        }
    };

    const fetchDiscountType = async () => {
        try {
            const data = await DiscountTypeService.GetAllStckCategories(redirectCallback);
            setDiscountTypeData(data);
        } catch (error) {
            console.error('Error fetching discount types:', error);
        }
    };

    useEffect(() => {
        fetchDiscountType();

        if (PartID > 0) {
            fetchStockDiscountCategory();
            fetchStockDiscount();
            fetchPart();
        }
        else {
            setStockDiscountData([]);
            setFormData({ DiscountTypeID: 0 });
        }

    }, [PartID]);

    const handleCreateStockDiscountClick = () => {
        setcurrentStockDiscount(null);
        setIsModalOpen(true);
    };

    const handleCreateStockDiscountCategoryClick = () => {
        setcurrentStockDiscountCategory(null);
        setIsModalDiscount(true);
    };

    const handleCloseDCModal = () => {
        setIsModalDiscount(false);
    };
    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleEditDCClick = (stock) => {
        debugger;
        setcurrentStockDiscountCategory(stock);
        setIsModalDiscount(true);
    };
    const handleEditClick = (stock) => {
        setcurrentStockDiscount(stock);
        setIsModalOpen(true);
    };

    const handleDeleteClick = async (ID) => {
        const confirmed = window.confirm("Are you sure you want to delete this contact?");
        if (confirmed) {
            try {
                await StockDiscountService.DeleteStockDiscount(redirectCallback, ID);
                fetchStockDiscount(); // Refresh the list after deletion
            } catch (error) {
                console.error('Error deleting stock discount:', error);
            }
        }
    };
    const handleDeleteDCClick = async (ID) => {
        const confirmed = window.confirm("Are you sure you want to delete this contact?");
        if (confirmed) {
            try {
                await StockDiscountCategoryService.DeleteStockDiscountCategory(redirectCallback, ID);
                fetchStockDiscountCategory();
            } catch (error) {
                console.error('Error deleting stock discount:', error);
            }
        }
    };

    const handleDiscountTypeChange = (event) => {
        setDiscountType(event.target.value);
    };

    const handleSubmitForm = async (event) => {
        event.preventDefault();
        try {
            // Get the selected value of Discount type
            const selectedDiscountType = event.target.elements.DiscountTypeID.value;
            const formData = {
                DiscountTypeID: selectedDiscountType,
                PK_Stock_ID: PartID
            };
            handleSubmit(event, formData, setFormData, setErrors);
            fetchPart();

        } catch (error) {
            console.error('Error submitting data:', error);
        }
    };
    const handleSuccess = () => {
        fetchStockDiscount(); // Refresh the list after submission
        handleCloseModal();   // Close the modal
    };
    const handleSuccessDC = () => {
        fetchStockDiscountCategory(); // Refresh the list after submission
        handleCloseDCModal();   // Close the modal
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
           <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-6">
                    <button className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleCreateStockDiscountCategoryClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                </div>
                <div className="col-sm-3">
                    <button className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleCreateStockDiscountClick}>
                        Quantity Break
                    </button>
                </div>
                <div className="col-sm-3" style={{ "textAlign": "right" }}>
                    
                </div>
            </div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-6">
                    <div className="table-responsive">
                        <table className="table m-0 table-hover">
                            <thead>
                                <tr>
                                    <th>Discount Category</th>
                                    <th style={{ "textAlign": "right" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {stockDiscountCategoryData.map((stock) => (
                                    <tr key={stock.ID}>
                                        <td>{stock.vc_Name}</td>
                                      
                                        <td style={{ "textAlign": "right" }}>
                                            <button className='text-info' style={{ "background": "none", "border": "none" }} onClick={() => handleEditDCClick(stock)}>
                                                <i className="icofont-edit" aria-hidden="true"></i>
                                            </button>
                                            <button style={{ "background": "none", "border": "none" }} className="text-danger" onClick={() => handleDeleteDCClick(stock.ID)}>
                                                <i className="icofont-ui-delete" aria-hidden="true"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-sm-6">
                    <div className="table-responsive">
                        <table className="table m-0 table-hover">
                            <thead>
                                <tr>
                                    <th>Discount Category</th>
                                    <th>Quantity Break</th>
                                    <th>Discount %</th>
                                    <th style={{ "textAlign": "right" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {StockDiscountList.map((stock) => (
                                    <tr key={stock.PK_Discount_ID}>
                                        <td>{stock.vc_Name}</td>
                                        <td>{stock.snt_QuantityBreak}</td>
                                        <td>{stock.dec_Discount}</td>
                                        <td style={{ "textAlign": "right" }}>
                                            <button className='text-info' style={{ "background": "none", "border": "none" }} onClick={() => handleEditClick(stock)}>
                                                <i className="icofont-edit" aria-hidden="true"></i>
                                            </button>
                                            <button style={{ "background": "none", "border": "none" }} className="text-danger" onClick={() => handleDeleteClick(stock.PK_Discount_ID)}>
                                                <i className="icofont-ui-delete" aria-hidden="true"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <CreateStockDiscount
                    modalInstance={modalInstance}
                    currentStockDiscount={currentStockDiscount}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}
                    DiscountTypeList={DiscountTypeList}
                    PartID={PartID}
                />
            )}
            {IsModalDiscount && (
                <CreateStockDiscountCategory
                    modalInstance={modalInstance}
                    currentStockDiscountCategory={currentStockDiscountCategory}
                    onClose={handleCloseDCModal}
                    onSuccess={handleSuccessDC}
                    DiscountTypeList={DiscountTypeList}
                    PartID={PartID}
                />
            )}
        </div>
    );
}

export default StockDiscountPage;
